import React, { useCallback } from 'react';
import { GoBackButton } from '../../../../1_atoms/GoBackButton/GoBackButton';
import { Stepper } from '../../../../1_atoms/Stepper/Stepper';
import { ReceiveFlowStep, useReceiveFlowContext, } from '../../contexts/receiveflow';
import { AmountScreen } from './components/AmountScreen';
import { InitialScreen } from './components/InitialScreen';
import { MainScreen } from './components/MainScreen';
import { ReviewScreen } from './components/ReviewScreen';
const allowedStepsToGoBackFrom = [
    ReceiveFlowStep.MAIN,
    ReceiveFlowStep.AMOUNT,
    ReceiveFlowStep.REVIEW,
];
const getBackStep = (step) => {
    switch (step) {
        case ReceiveFlowStep.MAIN:
            return ReceiveFlowStep.INITIAL;
        case ReceiveFlowStep.AMOUNT:
            return ReceiveFlowStep.MAIN;
        case ReceiveFlowStep.REVIEW:
            return ReceiveFlowStep.AMOUNT;
        default:
            return ReceiveFlowStep.AMOUNT;
    }
};
export const ReceiveFlow = () => {
    const { set, step } = useReceiveFlowContext();
    const onBackClick = useCallback(() => {
        set(prevState => (Object.assign(Object.assign({}, prevState), { step: getBackStep(step) })));
    }, [set, step]);
    return (React.createElement(React.Fragment, null,
        step !== ReceiveFlowStep.INITIAL && (React.createElement(GoBackButton, { onClick: onBackClick, disabled: !allowedStepsToGoBackFrom.includes(step) })),
        step !== ReceiveFlowStep.INITIAL && (React.createElement(Stepper, { className: "mt-6", steps: 5, activeStep: step })),
        React.createElement("div", { className: "mt-0 md:mt-10" },
            step === ReceiveFlowStep.INITIAL && React.createElement(InitialScreen, null),
            step === ReceiveFlowStep.MAIN && React.createElement(MainScreen, null),
            step === ReceiveFlowStep.AMOUNT && React.createElement(AmountScreen, null),
            [
                ReceiveFlowStep.REVIEW,
                ReceiveFlowStep.PROCESSING,
                ReceiveFlowStep.COMPLETED,
            ].includes(step) && React.createElement(ReviewScreen, null))));
};
